
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";
import permissions from "@/security/permissions";
import Input from "./Input.vue";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class DeliveryForSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {

  @Prop({ default: false })
  appendToBody: boolean;

  @Prop({ default: false })
  includeCDS: boolean;

  get firstDeliveryFor() {
    if(!this.types || this.types.length == 0)
      return "";
    
    setTimeout(() => 
    {
      this.$emit("update:modelValue", this.types[0].value);
    }, 250);

    return this.types[0]
  }

  get types() {
    var options = systemModule.deliveryFors
      .map(x => ({ 
          label: `${this.getActiveText(x.isActive)} ${this.getNameText(x.name)}`, 
          value: x.id ?? 0}));

    if(this.includeCDS || this.hasPermission(permissions.order.create)) {
      options.unshift({ label:"CDS Logistics", value: 0})
    }
    return options;
  }

  @Watch("localValue")
  localValuesChanged(newValue) {
    this.$emit("update:modelValue", newValue);
  }  

  getNameText(name) {
    return name || 'Name not available';
  }

  getActiveText(isActive) {
    return isActive ? '' : 'Inactive ';
  }
}
